var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesHomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8266 12.7922L20.9555 1.13438C20.7891 0.46875 20.1891 0 19.5 0H4.5C3.81141 0 3.21234 0.46875 3.04547 1.13672L0.174375 12.7945C0.0585 13.2609 0 13.7437 0 14.2266V18.75C0 19.9922 1.00734 21 2.25 21H21.75C22.9927 21 24 19.9927 24 18.75V14.228C24 13.7437 23.9437 13.2609 23.8266 12.7922ZM18 12L16.5 15H7.5L6 12H3.42047L5.67188 3H18.3281L20.5795 12H18ZM17.25 9H6.75C6.3375 9 6 9.3375 6 9.75C6 10.1625 6.3375 10.5 6.75 10.5H17.25C17.6625 10.5 18 10.1625 18 9.75C18 9.3375 17.6625 9 17.25 9ZM8.25 6.75H15.75C16.1625 6.75 16.5 6.4125 16.5 6C16.5 5.5875 16.1643 5.25 15.75 5.25H8.25C7.8375 5.25 7.5 5.5875 7.5 6C7.5 6.4125 7.8375 6.75 8.25 6.75Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesHomeIcon);
export default __webpack_public_path__ + "static/media/FilesHomeIcon.48d41c298b82e154b713af2109aa01f0.svg";
export { ForwardRef as ReactComponent };